import { createSelector } from "reselect"
import { get } from "lodash"
import { getViewType, getPeriod, getDate } from "modules/portfolio-root/selectors/portfolios"
import { getBaseStartDate } from "modules/portfolio-root/selectors/base"
import { getLatestDate as getPortfolioLatestDate, getEarliestDate as getPortfolioEarliestDate } from "modules/portfolio-root/selectors/dates"
import { getUnmodeledDates } from "selectors/dates"
import { getComparisonSecurities, getPortfolioExperiments, getSelectedComparisonType } from "."
import { getComparisonEndDate, getComparisonResourcesAvailability, getComparisonSecuritiesAvailability, getComparisonLatestDate, getComparisonWorkingPeriod, getComparisonSelectedDate, getComparisonStartDate, getComparisonExperimentsAvailability, getComparisonEarliestDate } from "helpers/comparison-dates"
import { getComparisonNonOverlappingItems } from "helpers/comparison"
import { getIndices } from "selectors/indices"
import { getBaskets } from "resources/baskets"

const EMPTY_ARRAY = []
const getPortfoliosAndBenchmarks = state => get(state, "global.data.benchmarksAndPortfolios.data")
const getModelEarliestDate = state => get(state, "global.data.dates.data.model.availability.securitiesStartDate")
const getRawSecuritiesAvailability = state => get(state, "global.data.securities.data.model")
const getComparisonItems = state => get(state, "modules.experiments.comparisonItems", EMPTY_ARRAY)
const getRawFrontierDate = state => get(state, "modules.experiments.frontierDate")

const getExperimentsAvailability = createSelector(
  [getPortfolioExperiments, getModelEarliestDate],
  getComparisonExperimentsAvailability,
)

const getPortfoliosAndBenchmarksAvailability = createSelector(
  [getPortfoliosAndBenchmarks, getModelEarliestDate, getIndices],
  getComparisonResourcesAvailability,
)

const getSecuritiesAvailability = createSelector(
  [getRawSecuritiesAvailability, getComparisonSecurities],
  getComparisonSecuritiesAvailability,
)

export const getLatestDate = createSelector(
  [getComparisonItems, getPortfolioLatestDate, getPortfolioEarliestDate, getSecuritiesAvailability],
  getComparisonLatestDate,
)

export const getEarliestDate = createSelector(
  [getPortfoliosAndBenchmarksAvailability, getPortfolioEarliestDate, getComparisonItems, getSecuritiesAvailability, getLatestDate, getSelectedComparisonType, getUnmodeledDates, getBaskets, getModelEarliestDate, getExperimentsAvailability],
  getComparisonEarliestDate,
)

export const getNonOverlappingItems = createSelector(
  [getPortfoliosAndBenchmarksAvailability, getPortfolioEarliestDate, getComparisonItems, getSecuritiesAvailability, getEarliestDate, getLatestDate, getExperimentsAvailability],
  getComparisonNonOverlappingItems,
)

const getWorkingPeriod = createSelector(
  [getPeriod, getLatestDate, getEarliestDate],
  getComparisonWorkingPeriod,
)

export const getStartDate = createSelector(
  [getWorkingPeriod, getLatestDate, getEarliestDate, getBaseStartDate, getViewType, getSelectedComparisonType, getUnmodeledDates],
  getComparisonStartDate,
)

export const getEndDate = createSelector(
  [getWorkingPeriod, getLatestDate],
  getComparisonEndDate,
)

export const getSelectedDate = createSelector(
  [getDate, getStartDate, getEndDate],
  getComparisonSelectedDate,
)

export const getFrontierDate = createSelector(
  [getRawFrontierDate, getDate, getEarliestDate, getLatestDate],
  (frontierDate, selectedDate, earliestDate, latestDate) => getComparisonSelectedDate(frontierDate || selectedDate, earliestDate, latestDate),
)

export const getFrontierDateAdjusted = createSelector(
  [getRawFrontierDate, getEarliestDate, getLatestDate],
  (frontierDate, startDate, endDate) => {
    if (frontierDate) {
      return frontierDate < startDate || frontierDate > endDate
    }

    return false
  },
)
